import { createI18n } from 'vue-i18n'

// default lang
import zhCN from './lang/zh-CN'
import enUS from './lang/en-US'

export const defaultLang = 'en-US'

// const messages = {
//   'en-US': {
//     ...enUS,
//   },
// }

const messages = {
  'en-US': {
    ...enUS,
  },
  'zh-CN': {
    ...zhCN,
  },
}

const i18n = new createI18n({
  silentTranslationWarn: true,
  locale: defaultLang,
  fallbackLocale: defaultLang,
  messages,
})

export default i18n
